/**
 * @generated SignedSource<<18af5232e8637085c52b0a8d345a1d48>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AnswerListItem_Question$data = {
  readonly id: string;
  readonly rawId: number | null | undefined;
  readonly textualAnswer: {
    readonly id: string;
    readonly textualAnswer: string | null | undefined;
  } | null | undefined;
  readonly title: string;
  readonly videoAnswer: {
    readonly video: {
      readonly " $fragmentSpreads": FragmentRefs<"AnswerListItem_Video">;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "AnswerListItem_Question";
};
export type AnswerListItem_Question$key = {
  readonly " $data"?: AnswerListItem_Question$data;
  readonly " $fragmentSpreads": FragmentRefs<"AnswerListItem_Question">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AnswerListItem_Question",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rawId",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Answer",
      "kind": "LinkedField",
      "name": "textualAnswer",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "textualAnswer",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Answer",
      "kind": "LinkedField",
      "name": "videoAnswer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Video",
          "kind": "LinkedField",
          "name": "video",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "AnswerListItem_Video"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Question",
  "abstractKey": null
};
})();

(node as any).hash = "27a19ec919ac7e74a52920210a510e26";

export default node;
